export const petClaimsMapping = {
    dog: 'Hund',
    cat: 'Kat',
    horse: 'Hest'
};
